var _circle, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpCircleAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "2.22rem",
    height: "2.22rem",
    viewBox: "0 0 40 40",
    alt: "Learn More Icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "helpAltCircle",
    strokeWidth: 2,
    cx: 20,
    cy: 19,
    r: 10.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "helpAltQuest",
    x: 18.72,
    y: 24,
    width: 2.4,
    height: 2.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "helpAltQuest",
    d: "M24.52,15.8a4.78,4.78,0,0,0-5.7-3.5,4.72,4.72,0,0,0-3.6,4.6h2.4a2.41,2.41,0,0,1,4.8.4,2.48,2.48,0,0,1-2.5,2,1.11,1.11,0,0,0-1.1,1.1h0v2.5h2.4V21.6A5,5,0,0,0,24.52,15.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCircleAlt);
export default __webpack_public_path__ + "static/media/HelpCircleAlt.7a8e0907.svg";
export { ForwardRef as ReactComponent };